import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATHS } from '../../../routes/Routes';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { FormTemplate } from '../../../types/FormTemplate';
import { mutationKeys } from '../mutationKeys';

const postFormTemplate = async (formData: FormTemplate) => {
  const response = await CustomAxios.post(`form_templates`, formData);
  const { data } = response;
  return data;
};

type useCreateFormTemplateProps = {
  onSuccessCallback: () => void;
};

export function useCreateFormTemplate({ onSuccessCallback }: useCreateFormTemplateProps) {
  const navigate = useNavigate();
  return useMutation({
    mutationKey: [mutationKeys.createFormTemplate],
    mutationFn: (formData: FormTemplate) => postFormTemplate(formData),
    onSuccess: (data: FormTemplate) => {
      // fetch again after create
      queryClient.invalidateQueries({ queryKey: [queryKeys.allFormTemplates, 'new'] });

      // call success
      onSuccessCallback();

      navigate(`/${ROUTE_PATHS.FORM_TEMPLATES}/${data.uuid}`);
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        // let set the query data with bad errored response
        const formTemplate: FormTemplate = err.response.data as FormTemplate;
        queryClient.setQueryData([queryKeys.allFormTemplates, 'new'], formTemplate);
      }
    },
  });
}
